import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import _ from 'lodash';
import { VIEWMODE } from 'src/app/shared/pages/view/view.component';

export interface IFileUploadDialogOptions {
    title: string;
    text: string;
    view_mode: VIEWMODE;
    maxFileSize: number;
    fileFormats: string[];
    multiple: boolean | number;
    control: FormControl;
}


@Component({
    selector: 'app-file-upload-dialog',
    templateUrl: './file-upload-dialog.component.html',
    styleUrls: ['./file-upload-dialog.component.scss']
})
export class FileUploadDialog {
    protected _defaultCtx: IFileUploadDialogOptions = {
        title: 'UPLOAD_FILE',
        text: 'PLEASE_UPLOAD_FILE',
        view_mode: VIEWMODE.EDIT,
        maxFileSize: 20000,
        fileFormats: [],
        multiple: false,
        control: new FormControl(),
    };

    public ctx: IFileUploadDialogOptions;

    constructor(
        public dialogRef: MatDialogRef<FileUploadDialog>,
        @Inject(MAT_DIALOG_DATA) public data: IFileUploadDialogOptions
    ) {
        this.ctx = _.assign(this._defaultCtx, this.data);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
